// PhoneMaskCustom.tsx
import React from 'react';
import { IMaskInput } from 'react-imask';

interface CustomProps {
  name: string;
  onChange: (event: { target: { name: string; value: string } }) => void;
  [key: string]: any; // For any other props that might be passed
}

const PhoneMaskCustom = React.forwardRef<HTMLInputElement, CustomProps>(
  function PhoneMaskCustom(props, ref) {
    const { onChange, ...other } = props;
    return (
      <IMaskInput
        {...other}
        mask="(000) 000-0000"
        inputRef={ref}
        onAccept={(value: any) =>
          onChange({ target: { name: props.name, value } })
        }
        overwrite
      />
    );
  }
);

export default PhoneMaskCustom;